import InfoIcon from '@mui/icons-material/Info';
import { Box, Typography } from '@mui/material';

import { useT } from 'UI/lib';

interface NoOptionsTextProps {
  search: string;
}

const NoOptionsText = ({ search }: NoOptionsTextProps) => {
  const t = useT();

  return (
    <Box display="flex" alignItems="center" gap={4}>
      <InfoIcon />
      <Typography data-test="skill-not-found-text">
        {t('common:search_not_found', { text: search })}
      </Typography>
    </Box>
  );
};

export default NoOptionsText;
